'use client';

import React from 'react';
import { getNavIcon } from '@/lib/nav-icons';
import type { LucideIcon, LucideProps } from 'lucide-react';

interface NavIconProps extends LucideProps {
  keyword?: string | null;
  fallback?: LucideIcon | null;
}

export function NavIcon({ keyword, fallback, ...rest }: NavIconProps) {
  const icon = getNavIcon(keyword) ?? fallback ?? null;
  if (!icon) return null;
  return React.createElement(icon, rest);
}
